/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'question-circle': {
    width: 30,
    height: 30,
    viewBox: '0 0 30 30',
    data: '<circle pid="0" cx="15" cy="15" r="15" _fill="#E84393"/>'
  }
})
